import _taggedTemplateLiteral from "/home/runner/work/web/web/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";

var _templateObject;

import styled, { css } from 'styled-components';
import { getColor, getSpace } from '@yoweb/ui/styles/utils/theme';
import { media, pxToRem } from '@yoweb/ui/styles/utils';
import { Text } from '@yoweb/ui/components/typography';
import { jsx as _jsx } from "react/jsx-runtime";
export var ActionModalHeader = function ActionModalHeader(_ref) {
  var title = _ref.title,
      textAlign = _ref.textAlign,
      borderless = _ref.borderless;
  return /*#__PURE__*/_jsx(ModalHeader, {
    borderless: !!borderless,
    children: /*#__PURE__*/_jsx(Text, {
      size: "md",
      weight: "bold",
      textAlign: textAlign,
      "data-testid": "action-modal-header-title",
      children: title
    })
  });
};
var ModalHeader = styled.div.withConfig({
  componentId: "sc-zxrzlm-0"
})(["padding:", " ", " ", ";min-height:", ";", " ", ""], getSpace('normal3'), getSpace('normal2'), getSpace('normal2'), pxToRem(70), function (_ref2) {
  var borderless = _ref2.borderless;
  return !borderless && css(["border-bottom:1px solid ", ";"], getColor('base100'));
}, media.md(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    padding: ", " ", " ", ";\n  "])), getSpace('normal3'), getSpace('normal4'), getSpace('normal2')));